import React, { useState } from "react";
import { useLang } from "../lib/LanguageContext";
import { standards, standardsEn, CONTACT } from "../lib/translations";
import { toast } from "sonner";
import { Send } from "lucide-react";

const EnquiryForm = () => {
  const { t, lang } = useLang();
  const [form, setForm] = useState({ parent: "", mobile: "", student: "", std: "" });
  const [loading, setLoading] = useState(false);
  const stdList = lang === "mr" ? standards : standardsEn;

  const handleChange = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.parent || !form.mobile || !form.student || !form.std) {
      toast.error(t.enquiry.validation);
      return;
    }
    if (!/^[6-9]\d{9}$/.test(form.mobile.replace(/\D/g, "").slice(-10))) {
      toast.error(lang === "mr" ? "कृपया योग्य १० अंकी मोबाईल क्रमांक टाका" : "Please enter a valid 10-digit mobile number");
      return;
    }
    setLoading(true);
    const msg = encodeURIComponent(
      (lang === "mr"
        ? `नमस्कार! प्रवेशासाठी चौकशी\n\n` +
          `पालकाचे नाव: ${form.parent}\n` +
          `मोबाईल: ${form.mobile}\n` +
          `विद्यार्थ्याचे नाव: ${form.student}\n` +
          `इयत्ता: ${form.std}\n\n` +
          `शाळा: ${t.schoolName}`
        : `Hello! Admission Enquiry\n\n` +
          `Parent Name: ${form.parent}\n` +
          `Mobile: ${form.mobile}\n` +
          `Student Name: ${form.student}\n` +
          `Standard: ${form.std}\n\n` +
          `School: ${t.schoolName}`)
    );
    const url = `https://wa.me/${CONTACT.whatsapp}?text=${msg}`;
    toast.success(t.enquiry.success);
    setTimeout(() => {
      window.open(url, "_blank", "noopener,noreferrer");
      setLoading(false);
      setForm({ parent: "", mobile: "", student: "", std: "" });
    }, 600);
  };

  return (
    <form onSubmit={handleSubmit} data-testid="enquiry-form" className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="md:col-span-1">
        <label className="block text-sm font-semibold text-school-text mb-2">{t.enquiry.parentName}</label>
        <input
          type="text"
          data-testid="enquiry-parent-name"
          value={form.parent}
          onChange={(e) => handleChange("parent", e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-school bg-white focus:outline-none focus:ring-2 focus:ring-school-primary focus:border-school-primary transition-all"
          placeholder={lang === "mr" ? "उदा. रमेश कुलकर्णी" : "e.g. Ramesh Kulkarni"}
        />
      </div>
      <div>
        <label className="block text-sm font-semibold text-school-text mb-2">{t.enquiry.mobile}</label>
        <input
          type="tel"
          data-testid="enquiry-mobile"
          value={form.mobile}
          onChange={(e) => handleChange("mobile", e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-school bg-white focus:outline-none focus:ring-2 focus:ring-school-primary focus:border-school-primary transition-all"
          placeholder={lang === "mr" ? "९९९९९ ९९९९९" : "99999 99999"}
        />
      </div>
      <div>
        <label className="block text-sm font-semibold text-school-text mb-2">{t.enquiry.studentName}</label>
        <input
          type="text"
          data-testid="enquiry-student-name"
          value={form.student}
          onChange={(e) => handleChange("student", e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-school bg-white focus:outline-none focus:ring-2 focus:ring-school-primary focus:border-school-primary transition-all"
          placeholder={lang === "mr" ? "उदा. आर्या कुलकर्णी" : "e.g. Arya Kulkarni"}
        />
      </div>
      <div>
        <label className="block text-sm font-semibold text-school-text mb-2">{t.enquiry.standard}</label>
        <select
          data-testid="enquiry-standard"
          value={form.std}
          onChange={(e) => handleChange("std", e.target.value)}
          className="w-full px-4 py-3 rounded-xl border border-school bg-white focus:outline-none focus:ring-2 focus:ring-school-primary focus:border-school-primary transition-all"
        >
          <option value="">{t.enquiry.selectStd}</option>
          {stdList.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div className="md:col-span-2 pt-2">
        <button
          type="submit"
          disabled={loading}
          data-testid="enquiry-submit-btn"
          className="w-full inline-flex items-center justify-center gap-2 bg-school-accent hover:bg-[var(--school-accent-dark)] disabled:opacity-60 text-white font-heading font-semibold py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
        >
          <Send className="w-5 h-5" />
          {t.enquiry.submit}
        </button>
      </div>
    </form>
  );
};

export default EnquiryForm;
